<template>
	<div>
		<div class="rtitle flex justify-between align-center bg-white rone">
			<div class="colorleft">服务记录</div>
			<div class="colorright">共{{totalnumnew ? totalnumnew : 0}}条</div>
		</div>
		<div class="cball">
			<div>
				<div v-if="zlist.length" class="flex justify-between aling-center flex-wrap" style="min-height: 570px">
					<div v-for="(item,index) in zlist" :key="index" class="bg-white"
						style="width: 487px;border-radius: 12px;margin-bottom: 10px;">
						<div class="" style="padding: 30px;border-bottom: 1px solid #eee;">
							<div class="flex justify-center align-center lastone">
								<div class="" style="width: 100px;color: #151515;font-size: 18px;">
									服务类型
								</div>
								<div class="flex-sub" v-if="item.type == 1" style="color: #838383;font-size: 18px;">技术服务
								</div>
								<div class="flex-sub" v-if="item.type == 2" style="color: #838383;font-size: 18px;">创业服务
								</div>
								<div class="flex-sub" v-if="item.type == 3" style="color: #838383;font-size: 18px;">租赁服务
								</div>
								<div class="flex-sub" v-if="item.type == 4" style="color: #838383;font-size: 18px;">培训服务
								</div>
								<div class="flex-sub" v-if="item.type == 5" style="color: #838383;font-size: 18px;">孵化服务
								</div>
								<div class="flex-sub" v-if="item.type == 6" style="color: #838383;font-size: 18px;">入驻企业
								</div>
								<!-- 1技术服务 2创业服务 3租赁服务 4培训 5融资 6入驻         -->
							</div>
							<div class="flex justify-center align-center lastone">
								<div class="" style="width: 100px;color: #151515;font-size: 18px;">
									咨询时间
								</div>
								<div class="flex-sub" style="color: #838383;font-size: 18px;">{{item.createtime}}</div>
							</div>
							<div class="flex justify-center align-center lastone">
								<div class="" style="width: 100px;color: #151515;font-size: 18px;">
									咨询状态
								</div>
								<div class="flex-sub" style="font-size: 18px;">
									<span style="color: #ffa800;" v-if="item.status == 0">未处理</span>
									<span style="color: #0fc4ad;" v-if="item.status == 1">处理中</span>
									<span style="color: #0055ff;" v-if="item.status == 2">已办结</span>
								</div>
							</div>
						</div>
						<div class="" style="padding: 22px 30px;">
							<div class="" style="color: #151515;font-size: 18px;margin-bottom: 15px;">
								服务内容
							</div>
							<div style="padding: 15px 20px;background-color: #f5f5f5;" class="text-cut2">
								<div class="text-cut2"
									style="min-height: 64px;color: #b6b5b5;font-size: 18px;line-height: 32px;">
									{{item.content}}
								</div>
							</div>
							<template v-if="item.detail">
								<div class="" style="color: #151515;font-size: 18px;margin: 15px 0;">
									回复内容
								</div>
								<div style="padding: 15px 20px;background-color: #f5f5f5;" class="text-cut2">
									<div class="text-cut2"
										style="min-height: 64px;color: #b6b5b5;font-size: 18px;line-height: 32px;">
										{{item.detail}}
									</div>
								</div>
							</template>
							<template v-if="item.file">
								<div class="" style="color: #151515;font-size: 18px;margin: 15px 0;">
									回复附件
								</div>
								<div style="padding: 10px 20px;" class="text-cut2">
									<a style="display: flex;align-items: center;color: #b6b5b5;text-decoration:none"
										target="_blank" :href="item.file | addurl">
										<img src="../../../static/assets/images/wenjian.png"
											style="width:40px;height:40px;margin-right: 10px;" />
										点击打开
									</a>
								</div>
							</template>
						</div>
					</div>
				</div>

				<div class=" bg-white" v-if="!zlist.length && !load" style="min-height: 480px;padding: 40px;">
					<el-empty description="暂无数据"></el-empty>
				</div>
				<div class="text-center" style="padding-top: 40px;">
					<el-pagination background layout="prev, pager, next" :pager-count="pagerCount"
						:hide-on-single-page="true" :page-size="pagesize" @size-change="handleSizeChangenew"
						@current-change="handleCurrentChangenew" :current-page="currentPagenew" :total="totalnumnew">
					</el-pagination>
				</div>
			</div>
		</div>

	</div>
</template>
<script>
	export default ({
		data() {
			return {
				config: '',
				totalnumnew: 0,
				zlist: [],
				pagerCount: 7,
				pagesize: 10,
				userinfo: '',
				currentPagenew: 1,
				load: true
			}
		},
		methods: {
			getconfig() {
				this.$api.index.config().then(res => {
					this.config = res.data;
				})
			},
			handleSizeChangenew() {

			},
			handleCurrentChangenew(currentPage) {
				this.currentPagenew = currentPage;
				this.getzlist();
			},
			getzlist() {
				var data = {
					user_id: this.userinfo.id,
					start: this.currentPagenew,
					page_size: this.pagesize
				}
				this.$api.index.my_question(data).then(res => {
					this.zlist = res.data;
					this.totalnumnew = res.count;
					this.load = false;
				}).catch(res => {
					// console.log(res,1111111111)
					this.load = false;
				})
			},
		},
		created() {
			this.userinfo = JSON.parse(localStorage.getItem('userinfo'));
			// this.getconfig();
			this.getzlist();
		}
	})
</script>

<style scoped>
	.rtitle {
		padding: 20px;
		font-size: 16px;
		color: #7d7d7d;
		border-bottom: 8px solid #f4f4f4;
	}

	.rone {
		border-radius: 12px 12px 0 0;
	}

	.colorleft {
		color: #191919;
		font-size: 20px;
	}

	.colorright {
		color: #7e7e7e;
		font-size: 18px;
	}




	.lastone {
		margin-bottom: 20px;
	}

	.lastone:last-child {
		margin-bottom: 0;
	}
</style>



// WEBPACK FOOTER //
// service_list.vue?22e512d3